"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getBetStatus = exports.factorial = exports.sumOfOddsSubsets = exports.isScoreMarketTwoRow = exports.isScoreMarket = exports.MarketGroupData = exports.getMarketGroupId = exports.getRandomRequestId = exports.getStakeValue = void 0;
exports.systemBetVariantsCount = systemBetVariantsCount;
const enums_1 = require("@finbackoffice/enums");
const constants_1 = require("../constants");
const getStakeValue = (stake, configs) => {
    const { maxBet, decimal_digits, isBetProcessorEnabled } = configs;
    if (isBetProcessorEnabled && parseFloat(stake) > maxBet) {
        return maxBet.toFixed(decimal_digits).toString();
    }
    if (!stake.includes(".")) {
        return stake;
    }
    const [int, frac] = stake.split(".");
    return `${int ?? "0"}${decimal_digits ? `.${frac.substring(0, decimal_digits)}` : ""}`;
};
exports.getStakeValue = getStakeValue;
const getRandomRequestId = (length) => {
    let result = "";
    const characters = "abcdefghijklmnopqrstuvwxyz0123456789";
    const charactersLength = characters.length;
    for (let i = 0; i < length; i++) {
        result += characters.charAt(Math.floor(Math.random() * charactersLength));
    }
    return result;
};
exports.getRandomRequestId = getRandomRequestId;
const getMarketGroupId = (market) => {
    const params = market.parameters ?? [];
    switch (market.template_id) {
        case constants_1.TemplateIdsMap.QUARTERNUMBER_QUARTER_TOTAL:
        case constants_1.TemplateIdsMap.QUARTERNUMBER_QUARTER_HANDICAP:
        case constants_1.TemplateIdsMap.QUARTERNUMBER_QUARTER_COMPETITOR1_TOTAL:
        case constants_1.TemplateIdsMap.QUARTERNUMBER_QUARTER_COMPETITOR2_TOTAL:
            return `${market.template_id}q${params.find((param) => param.label === "quarternr")?.value ?? ""}`;
        case constants_1.TemplateIdsMap.SETNUMBER_SET_POINT_HANDICAPS:
        case constants_1.TemplateIdsMap.SETNUMBER_SET_TOTAL_POINTS:
            return `${market.template_id}s${params.find((param) => param.label === "setnr")?.value ?? ""}`;
        case constants_1.TemplateIdsMap.PERIODNUMBER_PERIOD_HANDICAP:
        case constants_1.TemplateIdsMap.PERIODNUMBER_PERIOD_TOTAL:
            return `${market.template_id}p${params.find((param) => param.label === "periodnr")?.value ?? ""}`;
        case constants_1.TemplateIdsMap.INNINGS_FROMVALUE_TOVALUE_HANDICAP:
        case constants_1.TemplateIdsMap.INNINGS_FROMVALUE_TOVALUE_TOTAL:
        case constants_1.TemplateIdsMap.INNINGS_FROMVALUE_TOVALUE_COMPETITOR1_TOTAL:
        case constants_1.TemplateIdsMap.INNINGS_FROMVALUE_TOVALUE_COMPETITOR2_TOTAL: {
            const fromValue = params.find((param) => param.label === "from")?.value ?? "";
            const toValue = params.find((param) => param.label === "to")?.value ?? "";
            return `${market.template_id}f${fromValue}t${toValue}`;
        }
        case constants_1.TemplateIdsMap.INNINGNUMBER_INNING_TOTAL:
        case constants_1.TemplateIdsMap.INNINGNUMBER_INNING_HANDICAP: {
            const inningNumberValue = params.find((param) => param.label === "inningnr")?.value ?? "";
            return `${market.template_id}i${inningNumberValue}`;
        }
        default:
            return market.template_id.toString();
    }
};
exports.getMarketGroupId = getMarketGroupId;
const getFavoriteId = (market) => {
    switch (market.template_id) {
        case constants_1.TemplateIdsMap.DOUBLE_CHANCE_TOTAL:
            return `${market.template_id}-${market.outcomes[0].name
                ?.split("")
                .at(-1)}`;
        default:
            return market.template_id.toString();
    }
};
class MarketGroupData {
    id;
    template_id;
    name;
    markets;
    outcomes_count;
    rank;
    favId;
    homeTeamName;
    awayTeamName;
    constructor(market, id, homeTeamName, awayTeamName) {
        this.id = id;
        this.template_id = market.template_id;
        this.favId = getFavoriteId(market);
        this.name = market.name;
        this.markets = [market];
        this.outcomes_count = market.outcomes_count;
        this.rank =
            market.template_id === constants_1.TemplateIdsMap.WINNER_INCL_OVERTIME
                ? 0
                : market.template_id;
        this.homeTeamName = homeTeamName;
        this.awayTeamName = awayTeamName;
    }
}
exports.MarketGroupData = MarketGroupData;
const isScoreMarket = (marketTemplateId) => [
    constants_1.TemplateIdsMap.CORRECT_SCORE,
    constants_1.TemplateIdsMap.CORRECT_SCORE_V2,
    constants_1.TemplateIdsMap.CORRECT_SCORE_1ST_HALF,
    constants_1.TemplateIdsMap.CORRECT_SCORE_2ND_HALF,
    constants_1.TemplateIdsMap.SETNUMBER_SET_CORRECT_SCORE,
    constants_1.TemplateIdsMap.CORRECT_SCORE_SCOREVALUE_V2,
    constants_1.TemplateIdsMap.CORRECT_SCORE_1ST_HALF_SCOREVALUE,
    constants_1.TemplateIdsMap.PERIODNUMBER_PERIOD_CORRECT_SCORE,
].includes(marketTemplateId);
exports.isScoreMarket = isScoreMarket;
const isScoreMarketTwoRow = (marketTemplateId) => [constants_1.TemplateIdsMap.SETNUMBER_SET_CORRECT_SCORE].includes(marketTemplateId);
exports.isScoreMarketTwoRow = isScoreMarketTwoRow;
const sumOfOddsSubsets = (betItems) => {
    const count = betItems.length;
    const from = betItems.length;
    const oddsSubsets = [];
    for (let ind = 0; ind < count + 1; ind++) {
        oddsSubsets[ind] = [];
        for (let ind1 = 0; ind1 < from + 1; ind1++) {
            oddsSubsets[ind][ind1] = 0;
        }
    }
    oddsSubsets[0][0] = 1;
    for (let i = 1; i <= count; ++i) {
        oddsSubsets[i][0] = 1;
        for (let j = 1; j <= from && j <= i; ++j) {
            oddsSubsets[i][j] =
                oddsSubsets[i - 1][j] +
                    oddsSubsets[i - 1][j - 1] * parseFloat(betItems[i - 1].outcomeValue);
        }
    }
    return oddsSubsets;
};
exports.sumOfOddsSubsets = sumOfOddsSubsets;
const factorial = (value) => {
    let result = 1;
    for (let i = 1; i <= value; ++i) {
        result *= i;
    }
    return result;
};
exports.factorial = factorial;
function systemBetVariantsCount(betsAmount, systemBetSelection) {
    if (betsAmount < 3) {
        return 0;
    }
    return ((0, exports.factorial)(betsAmount) /
        ((0, exports.factorial)(systemBetSelection) * (0, exports.factorial)(betsAmount - systemBetSelection)));
}
const getBetStatus = (marketStatus, outcome) => {
    const { status, void_factor } = outcome;
    if (status === enums_1.MarketOutcomeStatus.Happened && void_factor === 0.5) {
        return enums_1.SportResultsStatus.WIN_VOID;
    }
    else if (status === enums_1.MarketOutcomeStatus.NotHappened &&
        void_factor === 0.5) {
        return enums_1.SportResultsStatus.LOSE_VOID;
    }
    else if (marketStatus === enums_1.MarketStatus.Refund ||
        (status === enums_1.MarketOutcomeStatus.NotHappened && void_factor === 1)) {
        return enums_1.SportResultsStatus.VOID;
    }
    else if (status === enums_1.MarketOutcomeStatus.Happened && void_factor === 0) {
        return enums_1.SportResultsStatus.WIN;
    }
    else if (status === enums_1.MarketOutcomeStatus.NotHappened && void_factor === 0) {
        return enums_1.SportResultsStatus.LOSE;
    }
    else if (status !== enums_1.MarketOutcomeStatus.Happened &&
        status !== enums_1.MarketOutcomeStatus.NotHappened) {
        return enums_1.SportResultsStatus.ACCEPTED;
    }
    return "";
};
exports.getBetStatus = getBetStatus;
//# sourceMappingURL=sportsbook.js.map